import React, { useRef } from "react";
import { connect } from "react-redux";
import {  Navigate, Link } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";

import { Avatar } from "primereact/avatar";
import Server from "./Server.js";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.op = React.createRef();
    this.Server = new Server();
    this.state = {
      Exit: this.props.Exit,
      sideBar: 0,
      GridDataForms: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      percentage: 0,
    };
  }
  componentDidMount() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      if (response.data.authData.userId) {
        that.setState({
          UId: response.data.authData.userId,
          credit: that.props.credit,
        });
        that.getUser(response.data.authData.userId);
      }
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  GetForms() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      Active: true,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataForms: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetForms", param, SCallBack, ECallBack);
  }
  getUser(user_id) {
    let that = this;
    that.setState({
      ShowLoading: 1,
    });
    this.Server.send(
      "MainApi/getuserInformation",
      { user_id: user_id },
      function (response) {
        let res = response.data.result[0] ? response.data.result[0] : {};
        let count = 0;
        let items = [
          "name",
          "birthDay",
          "codeMelli",
          "gender",
          "marital",
          "profile",
          "studyType",
          "address",
          "madrak",
          "username",
        ];
        for (let item in res) {
          if (items.indexOf(item) != -1 && res[item]) count++;
        }
        that.setState({
          profile: res.profile ? that.state.absoluteUrl + res.profile.split("public")[1] : null
            ? res.profile
            : res.gender == "زن"
            ? "./nophoto-woman.png"
            : "./nophoto-man.png",
          percentage: count * 10,
        });
        that.GetForms();
      },
      function () {
        that.GetForms();
      }
    );
  }
  render() {
    if (this.state.getUserData) {
      return <Navigate to={"/Club"} />;
    }
    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: this.props.bgColor || "#ebdd25",
          padding: 10,
          height: this.props.height || "auto",
        }}
      >
        {this.props.appData.tabs.footer_tab_5 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#333",
              }}
              to={`${process.env.PUBLIC_URL}${this.props.appData.tabs.footer_tab_5.link}`}
            >
              <img
                src={`./icons/${this.props.appData?.lName}/${this.props.appData.tabs.footer_tab_5.icon}`}
                style={{ width: 48 }}
              />
              <span
                style={{
                  fontSize: 12,
                  lineHeight: "initial",
                  fontWeight: "normal",
                }}
                className="sarv-title1"
              >
                {this.props.appData?.tabs?.footer_tab_5.title}
              </span>
            </Link>
          </div>
        )}
        {this.props.appData.tabs.footer_tab_4 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#333",
              }}
              to={`${process.env.PUBLIC_URL}${this.props.appData.tabs.footer_tab_4.link}`}
            >
              <img
                src={`./icons/${this.props.appData?.lName}/${this.props.appData.tabs.footer_tab_4.icon}`}
                style={{ width: 48 }}
              />
              <span
                style={{
                  fontSize: 12,
                  lineHeight: "initial",
                  fontWeight: "normal",
                }}
                className="sarv-title1"
              >
                {this.props.appData?.tabs?.footer_tab_4.title}
              </span>
            </Link>
          </div>
        )}
        {this.props.appData.tabs.footer_tab_3 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#333",
              }}
              to={`${process.env.PUBLIC_URL}${this.props.appData.tabs.footer_tab_3.link}`}
            >
              <img
                src={`./icons/${this.props.appData?.lName}/${this.props.appData.tabs.footer_tab_3.icon}`}
                style={{ position: "absolute", top: -5, width: 50 }}
              />

              <i
                className="fas fa-barcode-read"
                style={{ fontSize: 18, visibility: "hidden" }}
              ></i>
              <span
                style={{
                  fontSize: 12,
                  lineHeight: "initial",
                  fontWeight: "normal",
                }}
                className="sarv-title1"
              >
                {this.props.appData?.tabs?.footer_tab_3.title}
              </span>
            </Link>
          </div>
        )}
        {this.props.appData.tabs.footer_tab_2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#333",
              }}
              to={`${process.env.PUBLIC_URL}${this.props.appData.tabs.footer_tab_2.link}`}
            >
              <img
                src={`./icons/${this.props.appData?.lName}${this.props.appData.tabs.footer_tab_2.icon}`}
                style={{ width: 48 }}
              />
              <span
                style={{
                  fontSize: 12,
                  lineHeight: "initial",
                  fontWeight: "normal",
                }}
                className="sarv-title1"
              >
                {this.props.appData?.tabs?.footer_tab_2.title}
              </span>
            </Link>
          </div>
        )}
        {this.props.appData.tabs.footer_tab_1 && this.props.mobile && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onClick={() => {
              this.setState({ sideBar: 1 });
            }}
          >
            <img
              src={`./icons/${this.props.appData?.lName}${this.props.appData.tabs.footer_tab_1.icon}`}
              style={{ width: 48 }}
            />
            <span
              style={{
                fontSize: 12,
                lineHeight: "initial",
                fontWeight: "normal",
              }}
              className="sarv-title1"
            >
              {this.props.appData.tabs.footer_tab_1.title}
            </span>
          </div>
        )}

        <Sidebar
          visible={this.state.sideBar}
          modal={false}
          onHide={() => this.setState({ sideBar: false })}
          position="right"
        >
          <div style={{ direction: "rtl" }}>
            {this.props.fullname && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{textAlign:"center"}}>
                  <p >
                    <img src={this.state.profile} style={{width:70,borderRadius:50}} />
                  </p>
                  <p
                    style={{
                      fontFamily: "iranyekanwebmedium",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ color: "red" }}>{this.props.fullname}</span>{" "}
                    عزیز خوش آمدید
                  </p>
                </div>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: 85,
                marginTop: 30,
              }}
            >
              <CircularProgressbar
                value={this.state.percentage}
                text={`${this.state.percentage}%`}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: 85,
                marginTop: 30,
              }}
            >
              <Button
                className="iranyekanwebmedium  2"
                onClick={() => this.setState({ getUserData: 1 })}
                style={{ textAlign: "center", height: 40 }}
              >
                <span
                  className="iranyekanwebmedium"
                  style={{ width: "100%", fontSize: 17, fontWeight: "bold" }}
                >
                  ویرایش اطلاعات
                </span>
              </Button>
            </div>
            {this.props.username &&
              this.state.GridDataForms.map((item, index) => {
                return (
                  <Link
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#333",
                      fontSize: 19,
                      backgroundColor: "#eee",
                      padding: 5,
                      borderRadius: 5,
                      marginTop: 10,
                    }}
                    to={`${process.env.PUBLIC_URL}/Form?number=${item.number}&name=${item.name}`}
                  >
                    <i className={item.icon} style={{ marginLeft: 8 }} />

                    <span
                      style={{
                        fontFamily: "iranyekanwebmedium",
                        textAlign: "right",
                        fontSize: 14,
                      }}
                    >
                      {item.name}
                    </span>
                  </Link>
                );
              })}
          </div>
        </Sidebar>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Footer);
